import React, { useEffect, useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import { Box, Chip } from "@mui/material";
import { capitalize } from "../util";

export default function FilterChip(props) {
  const { multiple = false } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [value, setValue] = useState(multiple ? [] : "");

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    event.stopPropagation();
  };

  useEffect(() => {
    // Only close menu in single-select mode
    if (!multiple) {
      handleClose();
    }
    props.onChange(value);
  }, [value]);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleToggle = (item, event) => {
    if (multiple) {
      // Prevent menu from closing in multi-select mode
      event?.stopPropagation();
      const currentValue = Array.isArray(value) ? value : [];
      const newValue = currentValue.includes(item)
        ? currentValue.filter((v) => v !== item)
        : [...currentValue, item];
      setValue(newValue);
    } else {
      setValue(item);
    }
  };

  const getLabel = () => {
    if (multiple) {
      const selectedValues = Array.isArray(value) ? value : [];
      if (selectedValues.length === 0) {
        return props.label;
      } else if (selectedValues.length === 1) {
        return (
          <Box>
            {props.label} <span style={{ color: "#999" }}>|</span>{" "}
            <span style={{ color: "#78374a" }}>{capitalize(selectedValues[0])}</span>
          </Box>
        );
      } else {
        return (
          <Box>
            {props.label} <span style={{ color: "#999" }}>|</span>{" "}
            <span style={{ color: "#78374a" }}>{selectedValues.length} selected</span>
          </Box>
        );
      }
    } else {
      return value ? (
        <Box>
          {props.label} <span style={{ color: "#999" }}>|</span>{" "}
          <span style={{ color: "#78374a" }}>{capitalize(value)}</span>
        </Box>
      ) : (
        props.label
      );
    }
  };

  return (
    <div>
      <Chip
        label={getLabel()}
        onClick={handleClick}
        onDelete={
          (multiple ? (Array.isArray(value) ? value : []).length > 0 : value)
            ? () => {
                setValue(multiple ? [] : "");
              }
            : null
        }
      />
      <Menu
        id={`${props.label}-menu`}
        anchorEl={anchorEl}
        open={open}
        onClose={(event, reason) => {
          // In multi-select mode, only close on backdrop click or escape key, not on item selection
          if (multiple) {
            // Only close if clicking outside (backdrop) or pressing escape
            if (reason === "backdropClick" || reason === "escapeKeyDown") {
              handleClose();
            }
            // Don't close on menuItemClick in multi-select mode
          } else {
            // In single-select mode, close on any action
            handleClose();
          }
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        sx={{
          "& .MuiMenu-list": {
            minWidth: "240px",
            paddingBottom: "15px",
          },
        }}
      >
        {props.values.map((o, idx) => {
          const isSelected = multiple ? Array.isArray(value) && value.includes(o) : value === o;
          return (
            <MenuItem
              key={idx}
              onClick={(event) => {
                handleToggle(o, event);
              }}
            >
              {multiple && <Checkbox checked={isSelected} sx={{ mr: 1 }} />}
              {capitalize(o)}
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
}
